import "./styles.less";

import React, { FC } from "react";
import { Skeleton, Typography } from "antd";
import { DescriptionProps, useDescription } from "./Description.hook";

export const Description: FC<DescriptionProps> = props => {

	const {
		limitLength,
		hideInformation,
		expandable,
		description,
		showTitle,
		loading,
	} = useDescription(props);

	const ellipsis = hideInformation
		? { rows: limitLength, expandable: expandable, symbol: "Ver Más" }
		: false;

	return (
		<>
			{description && (
				<>
					{showTitle && <Typography.Title level={4}>Descripción</Typography.Title>}
					{loading ? (
						<Skeleton active />
					) : (
						<Typography.Paragraph
							className={"property-description"}
							ellipsis={ellipsis}>
							<span
								dangerouslySetInnerHTML={{
									__html: description,
								}}
							/>
						</Typography.Paragraph>
					)}
				</>
			)}
		</>
	);
};
